import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

//icon
import { SiLeetcode } from "react-icons/si";
import { FaYoutube } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
import { CgNotes } from "react-icons/cg";
import { FaInstagram } from "react-icons/fa6";



const Hero = ({ profileData, nextRef }) => {
    const [text, setText] = useState('');
    const fullText = "Hi, I'm Amit Bodaliya";
    const [showCursor, setShowCursor] = useState(true);


    function reloadPage() { window.location.reload(); }
    function openLink(link) { window.location.href = link; }


    useEffect(() => {
        let index = 0;
        const timer = setInterval(() => {
            if (index <= fullText.length) {
                setText(fullText.slice(0, index));
                index++;
            } else {
                clearInterval(timer);
            }
        }, 100);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const cursorTimer = setInterval(() => {
            setShowCursor((prev) => !prev);
        }, 500);
        return () => clearInterval(cursorTimer);
    }, []);


    const scrollToSection = () => {
        if (nextRef.current) { nextRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', easing: 'ease-in-out' }); }
    };


    return (
        <section className={`${isMobile ? "" : "min-h-screen"}  flex items-center justify-center px-4`}>
            <div className="text-center z-10 max-w-4xl mx-auto w-full">


                <div className={`${isMobile ? "pt-60 pb-40" : "pt-24 pb-28"} mb-8 animate-fade-in`}>

                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-cyan-300 to-teal-400">
                        {text}
                        <span className={`${showCursor ? 'opacity-100' : 'opacity-0'} transition-opacity`}>|</span>
                    </h1>
                    <p className="text-xl md:text-2xl lg:text-3xl text-gray-300 mb-4 animate-slide-up">
                        {profileData.title}
                    </p>
                    <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto animate-slide-up-delay">
                        {profileData.sub_title}
                    </p>
                </div>



                <div className={`w-fit grid ${isMobile ? "grid-cols-3" : "grid-cols-7"} justify-center gap-4 mx-auto`}>

                    {profileData.linkData.map((data, index) => (
                        <button key={index} onClick={() => openLink(data.link)}
                            className="layout_2_ h-26 w-24 flex flex-col items-center rounded-2xl justify-center border border-white">

                            {
                                (data.icon === "FaInstagram") ? (
                                    <FaInstagram className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "FaYoutube") ? (
                                    <FaYoutube className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "FaGooglePlay") ? (
                                    <FaGooglePlay className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "CgNotes") ? (
                                    <CgNotes className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "FaGithub") ? (
                                    <FaGithub className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "SiLeetcode") ? (
                                    <SiLeetcode className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (data.icon === "FaLinkedin") ? (
                                    <FaLinkedin className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }} />
                                ) : (
                                    <img src={data.icon} className="w-10 h-10 m-2 mb-4" style={{ color: 'white' }}></img>
                                )
                            }

                            <span className=" font-bold px-2 pb-1 text-sm">{data.title}</span>
                        </button>
                    ))}
                </div>


                <div className='h-10'></div>
                <div className='h-10'></div>


                <button
                    onClick={scrollToSection}
                    className="animate-bounce-slow inline-block"
                >
                    <FaChevronDown size={40} className="text-cyan-400" />
                </button>
            </div>
        </section>
    );
};

export default Hero;
